import React,{Component} from 'react';
import './ServicePage.css';

import { consortiumBanner, logo } from '../../_utils/images';
import Page from '@acri-tools/react-tools/components/Page/Page';
import routes from '../../_utils/routes';
import Footer from '../../components/Footer/Footer';
const image = require('./image.png')

interface Props{
}
interface State{
}

export default class ServicePage extends Component<Props, State> {

    render(){
        return (
        <Page 
            id="service"
            title="Service"
            footer={<Footer/>}
            banner={{
                bannerImage: consortiumBanner,
                topBar:{
                    routes: routes,
                    logo: logo,
                }
            }}
        >
            <div className="page-content">
                <div className="centered-content padding">
                    <div className="title-3">Overview</div>
                    <p>
                        The S3A production service will perform the processing of all raw data acquired by the Sentinel-3A satellite 
                        (using available auxiliary data) up to predefined product levels (L0, L1, L2) and delivery of the generated data via 
                        the service PRIP.
                    </p>
                    <p>
                        The production is based on a processing baseline (usually the latest one) retrieved from the Reference System 
                        and deployed in the production environment.
                    </p>
                    <p>
                        The S3A Production Service is provided to ESA under a Service Level Agreement (see the KPI section of this site).
                        Note: both the S3A and S3B production services share the same specification (e.g. interfaces, performance, output 
                        products specification…) to ensure full transparency of data production for the users and to be fully interchangeable. 
                        Upon request from ESA, the S3A production service may provide a back-up solution for S3B production.
                    </p>
                    <br/>
                    <p>
                        <b>The Sentinel-3A systematic production service includes the following activities:</b>
                    </p>

                    <ul>
                        <li>
                            Deployment of up-to-date processing baselines (from Reference System)
                        </li>
                        <li>
                            Download of input products from XBIP (all available products are downloaded)
                        </li>
                        <li>
                            Download of auxiliary products (all available auxiliary products are downloaded)
                        </li>
                        <li>
                            Ingestion of input products and AUX for processing
                        </li>
                        <li>
                            Processing chains to generate L0, L1, L2 for all instruments
                        </li>
                        <li>
                            Delivery of AUX and generated products on the service PRIP (rolling archive)
                        </li>
                        <li>
                            Monitoring and enforcement of the production service SLA
                        </li>
                    </ul>
                    <img className="image" src={image}/>
                </div>
            </div>
        </Page>
        );
    }


};